<script setup>
import { defineEmits, ref } from 'vue'
import AppleStoreIcon from '@/pages/global/verifyMetaData/assets/AppleStoreIcon.png'
import GooglePlayIcon from '@/pages/global/verifyMetaData/assets/GoogleShopIcon.png'
import lang from '@/pages/global/verifyMetaData/lang.json'
import getUA from '@utils/getUA'

const defaultLocal =
  navigator.language === 'zh-TW' ? 'zh-TW' : navigator.language.split('-')[0]
const local = ref(defaultLocal)
const languages = new Proxy(lang, {
  get: function (target, property) {
    if (target[property]) {
      return target[property][local.value] || target[property].en
    }
    return ''
  }
})

const emits = defineEmits(['track'])

/**
 * 跳转到官网
 * */
const handleToDownload = () => {
  const storeUrl = getUA().isIOS
    ? 'https://apps.apple.com/us/app/timemark-timestamp-camera-gps/id6446071834'
    : 'https://play.google.com/store/apps/details?id=com.oceangalaxy.camera.new'
  emits('track', 'download', { url: storeUrl })
  window.location.href = storeUrl
}

/**
 * 跳转到Google表单
 * */
const handleToGoogleForm = () => {
  emits('track', 'moreInfo', {
    url: 'https://docs.google.com/forms/d/e/1FAIpQLScMxpuOJXL4fzxRMrhlZPs6-g0uoG3lo76cu6SQlT1tjXZupA/viewform?usp=header'
  })
  window.location.href =
    'https://docs.google.com/forms/d/e/1FAIpQLScMxpuOJXL4fzxRMrhlZPs6-g0uoG3lo76cu6SQlT1tjXZupA/viewform?usp=header'
}
</script>

<template>
  <div class="footer-wrapper">
    <div class="lookMoreBtn" @click="handleToGoogleForm">
      {{ languages.i_looking_for_more_info }}
    </div>
    <div class="title">{{ 'Timemark' }}</div>
    <div class="titleText">{{ languages.i_proof_in_every_photo }}</div>
    <div class="btn">
      <div class="icon"><img :src="AppleStoreIcon" alt="" /></div>
      <div class="icon" :style="{ marginRight: '14px' }">
        <img :src="GooglePlayIcon" alt="" />
      </div>
      <div @click="handleToDownload">{{ languages.i_download_now }}</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.footer-wrapper {
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .lookMoreBtn {
    padding: 4px 20px;
    border-radius: 16px;
    border: 1px solid rgba(197, 211, 224, 1);
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: rgba(61, 110, 153, 1);
    margin-bottom: 60px;
  }

  .title {
    font-weight: 590;
    font-size: 16px;
    margin-bottom: 10px;
  }

  .titleText {
    font-size: 16px;
    line-height: 100%;
    margin-bottom: 30px;
  }

  .btn {
    width: 215px;
    height: 50px;
    background: rgba(0, 0, 0, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgba(255, 255, 255, 1);
    font-weight: 590;
    font-size: 16px;
    border-radius: 5px;

    .icon {
      width: 18px;
      height: 18px;
    }
  }
}
</style>
